"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.EditorialDocumentDefaultProps = exports.EditorialDocument = void 0;
var _editorialDocument = _interopRequireDefault(require("./components/editorial-document"));
exports.EditorialDocument = _editorialDocument["default"];
var _editorialDocument2 = _interopRequireDefault(require("./components/editorial-document.props/editorial-document.defaultProps"));
exports.EditorialDocumentDefaultProps = _editorialDocument2["default"];